import { BlitzPage } from "@blitzjs/next"
import { TES_NATIONAL_EXPLORER_TITLE } from "app/constants"
import Layout from "app/core/layouts/Layout"
import { PRVIMapBanner } from "app/features/dashboard/components/release-banner"
import NationalMap from "app/features/national-map"
import { NoSSR } from "components/nossr"
import { Suspense } from "react"
import { useTranslation } from "react-i18next"

const NationalExplorer: BlitzPage = () => {
  const { i18n } = useTranslation()
  const lng = i18n?.language === "es" ? "es" : "en"
  return (
    <Suspense fallback={null}>
      <NoSSR>
        <PRVIMapBanner lng={lng} />
        <NationalMap />
      </NoSSR>
    </Suspense>
  )
}

NationalExplorer.getLayout = (page) => <Layout title={TES_NATIONAL_EXPLORER_TITLE}>{page}</Layout>
export default NationalExplorer
